<app-create-link *ngIf="english"></app-create-link>
<app-create-link-hindi *ngIf="hindi"></app-create-link-hindi>